export default {
  addGeoFence: {
    label: "Agregar Nueva Ubicación",
  },
  general: "General",
  geofencesTable: {
    label: "Resumen de Ubicaciones",
  },
  label: "Inventario de Flota",
  map: "Mapa",
  movement: "Movimiento",
  movementHistory: "Historial de Movimiento",
  multiSelectLabel: "Ubicación",
  noPolygonWarning: "Debe seleccionarse una ubicación",
  technicalDetails: "Detalles Técnicos",
};
